import { OpenedContract, toNano } from '@ton/core'
import { BoxV0 } from '@voteboxio/core'
import { useAppContext } from '../contexts/App.context'

export const useVote = (
  openedContact: OpenedContract<BoxV0.BoxV0> | undefined,
  recommendedVoteGas: string,
) => {
  const { sender } = useAppContext()

  const sendVote = async (
    index: number,
    amount: string,
  ): Promise<{ isSuccess: boolean }> => {
    if (!openedContact || !amount) {
      console.error('Failed to send user vote')
      return { isSuccess: false }
    }

    try {
      if (!sender) {
        throw new Error('Use vote without sender')
      }

      const userTonStake = toNano(amount)
      const queryId = BigInt(Date.now()) // @TODO improve maybe?

      const result = await openedContact.send(
        sender,

        { value: BigInt(userTonStake) + BigInt(recommendedVoteGas) },

        {
          $$type: 'Vote',
          choice: BigInt(index),
          ton_stake: BigInt(userTonStake),
          query_id: queryId,
        },
      )
      console.log(result)
      return { isSuccess: true }
    } catch (error) {
      console.error('Error sending user vote', error)
      return { isSuccess: false }
    }
  }

  const isValidVotingAmount = (amount: string) => {
    if (Number(amount) > 0) {
      return true
    }

    return false
  }

  return {
    sendVote,
    isValidVotingAmount,
  }
}
